module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAbklEQVR4AWOgCzgnqEYkopuG/6jg199/769cenvxApCBJoVFA1DJ3W1rNjeUHOxtvrdt7V+CGn7//Xe6qyajq7RiXsu5vobff/4SYcPajZvKy9aWFwIZaG7C5Ye/b85eAiKcfmCwWEEkooOGQQkAbq8RU3/SVj8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PY.png
// module id = 1248
// module chunks = 0